/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentUpdateUserArticleMutationRequest, ContentUpdateUserArticleMutationResponse, ContentUpdateUserArticlePathParams } from "../models/ContentUpdateUserArticle";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { contentUpdateUserArticle } from "../axios/contentUpdateUserArticle";
import { useMutation } from "@tanstack/react-query";

export const contentUpdateUserArticleMutationKey = () => ["content-ai-api", { url: '/contents/:id/user-article' }] as const

export type ContentUpdateUserArticleMutationKey = ReturnType<typeof contentUpdateUserArticleMutationKey>

/**
 * @summary Set article content after user edition
 * {@link /contents/:id/user-article}
 */
export function useContentUpdateUserArticle<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentUpdateUserArticleMutationResponse, ResponseErrorConfig<Error>, {id: ContentUpdateUserArticlePathParams["id"], data: ContentUpdateUserArticleMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentUpdateUserArticleMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? contentUpdateUserArticleMutationKey()

  return useMutation<ContentUpdateUserArticleMutationResponse, ResponseErrorConfig<Error>, {id: ContentUpdateUserArticlePathParams["id"], data: ContentUpdateUserArticleMutationRequest}, TContext>({
    mutationFn: async({ id, data }) => {
      return contentUpdateUserArticle(id, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}